<script lang="ts" setup>
import type { CatalogInApp } from '~/interfaces/app';

const props = defineProps({
  item: {
    type: Object as () => CatalogInApp,
    required: true,
  },
  showArrow: {
    type: Boolean,
    default: false,
  },
  isDesktopHeading: {
    type: Boolean,
    default: false,
  },
  greyHover: {
    type: Boolean,
    default: false,
  },
  blueHover: {
    type: Boolean,
    default: false,
  },
  isGrey: {
    type: Boolean,
    default: false,
  },
  last: {
    type: Boolean,
    default: false,
  },
  isTablet: {
    type: Boolean,
    default: false,
  },
});
const router = useRouter();

const getUrl = (url: string): string => {
  if (url.endsWith('/')) return `/${url}`;
  return `/${url}/`;
};
const toGo = (url: string) => {
  if (!import.meta.env.SSR && !props.isTablet) {
    const setsUrl = getUrl(url);
    router.push(setsUrl);
  }
};
</script>
<template>
  <li
    class="menu-item"
    :class="{
      showArrow: showArrow,
      isDesktopHeading: isDesktopHeading,
      greyHover: greyHover,
      isGrey: isGrey,
      blueHover: blueHover,
      last: last,
    }"
  >
    <a
      itemprop="url"
      class="menu-item-link"
      :href="getUrl(item.url)"
      @click.prevent="toGo(item.url)"
    >
      {{ item.title }}
    </a>
    <slot />
  </li>
</template>

<style lang="scss" scoped>
.menu-item {
  @include fz(14, 20, 400);
  border-bottom: 1px solid #f5f5f5;
  position: relative;
  padding-right: 10px;
  list-style: none;
  transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out;
  @include xl-block {
    border: none;
    &:before {
      content: '';
      position: absolute;
      width: 3px;
      height: 24px;
      left: 0;
      top: calc(50% - 12px);
      background: transparent;
      transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out;
    }
  }

  &.last {
    border-bottom: 1px solid transparent;
  }

  a {
    padding: 12px 0 11px;
    cursor: pointer;
    display: block;
    @include xl-block {
      padding: 0;
    }
  }

  &.isDesktopHeading {
    @include xl-block {
      @include fz(16, 24, 700);
    }
    @include xl-block {
      a {
        padding: 0;
      }
    }
  }

  &.greyHover {
    @include xl-block {
      padding: 12px 0 12px 28px;
      border-radius: 4px 0 0 4px;
      @include fz(16, 24, 450);
      &:hover {
        background-color: $achromatic-card-bg;
      }
    }
  }

  &.isGrey {
    @include xl-block {
      background-color: $achromatic-card-bg;
      &:before {
        background: $main-cta;
      }
    }
  }

  &.blueHover {
    .menu-item-link {
      @include xl-block {
        &:hover {
          color: $hover-cta;
        }
      }
    }
  }

  &.showArrow {
    &:after {
      content: '';
      background: $achromatic-disabled;
      mask-image: url('/static/images/icon/arrow-left.svg');
      position: absolute;
      width: 10px;
      height: 8px;
      transform: translateY(-50%) rotate(90deg);
      mask-size: contain;
      mask-repeat: no-repeat;
      mask-position: center;
      top: 50%;
      right: 4px;
      @include md-block {
        width: 14px;
        height: 8px;
      }
      @include xl-block {
        display: none;
      }
    }
  }
}
</style>
